import React, {Fragment, useRef, useState,useEffect} from "react";
import {MobCard} from "../components/MobCard";
import {MobEditButton} from "../components/MobEditButton";
import {MobAddButton} from "../components/MobAddButton";
import {Trans} from "@lingui/react/macro";
import ModalAddField from "../../views/app-views/contact/ModalAddField";
import {useActionSheet} from "../providers/ActionSheetProvider";
import ModalAddCom from "../../views/app-views/contact/ModalAddCom";
import {checkForfait, checkPermissions} from "../../components/permissions/functions";
import {Avatar, Button, Card, Col, Dropdown, Menu, notification, Popconfirm, Row, Tag} from "antd";
import IntlMessage from "../../components/util-components/IntlMessage";
import ApiService from "../../services/ApiService";
import {MoreOutlined} from "@ant-design/icons";
import moment from "moment";
import {connect} from "react-redux";
import {DynamicIcon} from "lucide-react/dynamic";
import {Popover} from "antd-mobile";
import {contactCopie} from "./functions";
import {t} from "@lingui/core/macro";
import {MOBCOLORS} from "../../configs/AppConfig";

export default function ContactTabInteractions({selected}){

    return(
        <div style={{display:"flex",flexDirection:"column",gap:30,paddingTop:20}}>
            <CardInteractions selected={selected}/>
        </div>
    )
}


function CardInteractions({selected}) {
    const modalAddCom = useRef(null)
    const actionSheetManager = useActionSheet()


    return(
        <>
            <div style={{display: "flex", flexDirection: "column", gap: 10}}>

                <div style={{display:"flex",alignSelf:"flex-end"}}>
                    <MobAddButton text={(<Trans>Ajouter une interaction</Trans>)} onClick={()=>modalAddCom.current.show(selected.id)}/>
                </div>

                {selected.commentaires.length>0 &&(
                    <div style={{display:"flex",flexDirection:"column", gap:20}}>
                        {
                            [...selected.commentaires].reverse().map((item, index) => {
                                return (
                                    <CardCom contact={selected.id} item={item} editable onChange={() => selected.__refreshData()} actionSheetManager={actionSheetManager}/>
                                )
                            })
                        }
                    </div>
                )}
            </div>

            <ModalAddCom getRef={(ref) => modalAddCom.current = ref} onFinish={() => selected.__refreshData()}/>
        </>
    )
}

class _CardCom extends React.Component {

    async onDelete() {
        const {contact, item, onChange} = this.props

        if (!checkPermissions(["contact.edit"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        await ApiService.post("/contact/commentaire/delete/" + item.id + "/" + contact)

        if (onChange) {
            onChange()
        }

        notification.success({
            message: <IntlMessage id="success.delete"/>
        })
    }

    renderAccessAvatar(access) {
        const org = this.props.org

        let bgColor = "#000"
        let shortName = access?.prenom.slice(0, 3).toUpperCase()

        const _access = org.accessList.find(i => i.id === access.id)
        if (_access && _access.shortName) {
            shortName = _access.shortName
        }
        if (_access && _access.color) {
            bgColor = _access.color
        }

        return (
            <Avatar size="small" style={{backgroundColor: bgColor, color: "#FFF"}}>{shortName}</Avatar>
        )
    }

    render() {
        const {contact, item, editable, onChange} = this.props

        return (
            <Fragment>
                <Card
                    style={{borderRadius:10,boxShadow:"none"}}
                    headStyle={{padding:"0px 15px",paddingTop:3}}
                    bodyStyle={{paddingBottom:5,paddingRight:10}}
                    title={(
                        <Fragment>
                            <Tag color="magenta">{item.type}</Tag>
                            {item.accessId && (
                                <Tag color="processing">{item.accessPrenom} {item.accessNom}</Tag>
                            )}
                            {item.access && this.renderAccessAvatar(item.access)}
                        </Fragment>
                    )}
                    extra={editable && (
                        <div style={{display:"flex",justifyContent:"flex-end",alignItems:"center",gap:10}}>

                            <div style={{padding:5}} onClick={()=>this.modalAddCom.show(contact, item)}>
                                <DynamicIcon name={"edit"} color={"#000"} size={20} style={{display:"flex",justifyContent:"center",alignItems:"center"}} />
                            </div>


                            <div style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                gap: 10
                            }}>
                                <div style={{display: "flex", alignItems: "center"}}
                                     onClick={() => {
                                         this.props.actionSheetManager.confirm(t`Êtes-vous sûrs de vouloir supprimer cette interaction du ${moment(item.datetime).format("dddd DD MMMM YYYY à HH:mm")} ?`, () => {
                                             this.onDelete()
                                         })
                                     }}>
                                    <DynamicIcon name={"trash-2"} color={MOBCOLORS.red.color} size={20}
                                                 style={{
                                                     display: "flex",
                                                     justifyContent: "center",
                                                     alignItems: "center"
                                                 }}/>
                                </div>

                            </div>

                        </div>
                    )}
                >

                    {Array.isArray(item.actions) && item.actions.length > 0 && (
                        <Row style={{gap: 5, marginBottom: 20}}>
                            {item.actions.map((i, k) => {
                                return (
                                    <Tag key={k} color="lime">{i}</Tag>
                                )
                            })}
                        </Row>
                    )}

                    <Col>
                        <span style={{}}>{item.content}</span>
                    </Col>

                    <Col style={{display: "flex", justifyContent: "flex-end"}}>
                        <span style={{fontWeight:"300",fontSize:13}}>{moment(item.datetime).format("dddd DD MMMM YYYY à HH:mm")}</span>
                    </Col>

                </Card>
                <ModalAddCom getRef={(ref) => this.modalAddCom = ref} onFinish={() => {
                    if (onChange) {
                        onChange()
                    }
                }}/>
            </Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        org: state.auth.org
    }
};

export const CardCom=connect(mapStateToProps)(React.memo(_CardCom));


function Divider() {
    return (
        <div style={{width: "100%", paddingLeft: "5%", opacity: 0.05}}>
            <div style={{width: "100%", borderTop: "1px solid #4A5568"}}/>
        </div>
    )
}
